/** @format */

import { AxiosError } from "axios";
import { API_ENDPOINTS } from "../constants/api";
import {
  TOrgApiResponse,
  TOrgLinkRequest,
  TOrgPerson,
  TOrgRole,
  TOrgStructure,
  TOrgStructureRequest,
  TOrgUser,
} from "../redux-modules/declarations/maps/organigramma";
import apiClient from "../utils/apiClient";

const unwrap = async <T>(request: Promise<{ data: TOrgApiResponse<T> }>): Promise<T> => {
  const response = await request;
  return response.data.data as T;
};

/** Messaggio leggibile da un errore axios (usa il "message" restituito dal backend). */
export const organigrammaErrorMessage = (err: unknown, fallback: string): string => {
  const axiosError = err as AxiosError<TOrgApiResponse<unknown>>;
  return axiosError?.response?.data?.message || fallback;
};

export const apiOrganigrammaTree = (): Promise<TOrgPerson[]> =>
  unwrap(apiClient.get(API_ENDPOINTS.ORGANIGRAMMA));

export const apiOrganigrammaUsers = (): Promise<TOrgUser[]> =>
  unwrap(apiClient.get(API_ENDPOINTS.ORGANIGRAMMA_USERS));

export const apiOrganigrammaLinkSave = (link: TOrgLinkRequest): Promise<TOrgApiResponse<unknown>> =>
  apiClient.post(API_ENDPOINTS.ORGANIGRAMMA_LINK_SAVE, link).then(res => res.data);

export const apiOrganigrammaLinkDelete = (userId: number): Promise<TOrgApiResponse<unknown>> =>
  apiClient.post(API_ENDPOINTS.ORGANIGRAMMA_LINK_DELETE, { user_id: userId }).then(res => res.data);

export const apiOrganigrammaRoles = (): Promise<TOrgRole[]> =>
  unwrap(apiClient.get(API_ENDPOINTS.ORGANIGRAMMA_ROLES));

export const apiOrganigrammaRoleCreate = (name: string): Promise<TOrgRole> =>
  unwrap(apiClient.post(API_ENDPOINTS.ORGANIGRAMMA_ROLE_CREATE, { name }));

export const apiOrganigrammaRoleUpdate = (roleId: number, name: string): Promise<TOrgRole> =>
  unwrap(apiClient.post(API_ENDPOINTS.ORGANIGRAMMA_ROLE_UPDATE, { role_id: roleId, name }));

export const apiOrganigrammaRoleDelete = (roleId: number): Promise<{ removed_users: number }> =>
  unwrap(apiClient.post(API_ENDPOINTS.ORGANIGRAMMA_ROLE_DELETE, { role_id: roleId }));

export const apiOrganigrammaStructures = (): Promise<TOrgStructure[]> =>
  unwrap(apiClient.get(API_ENDPOINTS.ORGANIGRAMMA_STRUCTURES));

export const apiOrganigrammaStructureCreate = (
  structure: TOrgStructureRequest,
): Promise<TOrgStructure> =>
  unwrap(apiClient.post(API_ENDPOINTS.ORGANIGRAMMA_STRUCTURE_CREATE, structure));

export const apiOrganigrammaStructureUpdate = (
  id: number,
  structure: TOrgStructureRequest,
): Promise<TOrgStructure> =>
  unwrap(apiClient.post(API_ENDPOINTS.ORGANIGRAMMA_STRUCTURE_UPDATE, { id, ...structure }));

export const apiOrganigrammaStructureDelete = (id: number): Promise<TOrgApiResponse<unknown>> =>
  apiClient.post(API_ENDPOINTS.ORGANIGRAMMA_STRUCTURE_DELETE, { id }).then(res => res.data);
